export default {
  content: ''+
  '<div class="text-box">'+
  '<h3 class="h3-line">1.	空气动力学物理引擎</h3>'+
  '<p class="text-line">作用在无人机上的空气动力，包括升力和阻力，这是由于空气本身是有质量造成的。要产生支持力，气团必须被加速以产生向上的支持力，要达到平衡，则支持力必须等于重力。飞机在飞行中，机翼穿过气流，从而引起扰动，除了机翼外，飞机的其他部分，如机身、尾翼、起落架等也会引起扰动，空气动力学引擎需要模拟无人机飞行时的空气动力学特性。</p>'+
  '<img class="img-line" src="/work/static/img/uva/verification/t23-new.jpg" width="100%" />' +
  '<h3 class="h3-line">2.	无人机数字孪生体飞行仿真</h3>'+
  '<p class="text-line">ModelStudio-UAV为无人机数字孪生体模型的飞行仿真构建了数字孪生大气环境模型以及三维场景模型，并实现无人机数字孪生体的仿真过程控制。</p>'+
  '<img class="img-line" src="/work/static/img/uva/verification/t24.jpg" width="100%" />' +
  '</div>'
}